/**
 * Vue Router hands over an array when a param is repeated in the URL (`?term=a&term=b`),
 * and every list screen reads these values as single scalars. Normalising them at the
 * query boundary keeps a repeated param from reaching the state as an array.
 */
export function firstQueryValue(raw: unknown): string | undefined {
  if (typeof raw === 'string') return raw;
  if (Array.isArray(raw) && typeof raw[0] === 'string') return raw[0];
  return undefined;
}

/**
 * Reads a page size from the query, validated against the sizes the screen offers.
 * Anything absent, unknown or malformed falls back to the screen default.
 */
export function parseQuantityFromQuery(
  raw: unknown,
  options: readonly number[],
  fallback: number
): number {
  const value = Number(firstQueryValue(raw));
  return options.includes(value) ? value : fallback;
}
